<label class="config-container">
  <div class="inner-container" (click)="openModal()">
    <span class="name" tappable [attr.data-cy]="nameFieldTestId"
      >{{settingName}}
      <ion-icon
        *ngIf="moreInfoModalProps"
        color="primary"
        tappable
        (click)="displayMoreInfoModal($event)"
        ios="information-circle-sharp"
        md="information-circle"
        [attr.data-cy]="iconTestId"
      ></ion-icon
    ></span>
    <ion-label class="value">
      {{settingCurrentValue === '' ? settingPlaceholder : settingCurrentValue}}
    </ion-label>
  </div>
</label>
